import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bac8f696"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oxd-input-group__label-wrapper"
}
const _hoisted_2 = {
  key: 1,
  class: "oxd-file-input-div"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_label = _resolveComponent("oxd-label")!
  const _component_oxd_icon = _resolveComponent("oxd-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.hasLabel)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_oxd_label, { label: _ctx.labelText }, null, 8, ["label"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("input", _mergeProps({
      ref: "input",
      type: "file"
    }, _ctx.$attrs, {
      class: _ctx.fileInputClasses,
      onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
      onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }), null, 16),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.classes),
      style: _normalizeStyle(_ctx.style),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true),
      (!_ctx.$slots.default)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_ctx.buttonLabel)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({'oxd-file-button': true, '--disabled': _ctx.disabled})
                }, _toDisplayString(_ctx.buttonLabel), 3))
              : _createCommentVNode("", true),
            (_ctx.isSingle)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.inputValue ? _ctx.inputValue : _ctx.placeholderText), 1))
              : _createCommentVNode("", true),
            (_ctx.buttonIcon)
              ? (_openBlock(), _createBlock(_component_oxd_icon, {
                  key: 2,
                  class: _normalizeClass({'oxd-file-input-icon': true, '--disabled': _ctx.disabled}),
                  name: _ctx.buttonIcon
                }, null, 8, ["class", "name"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ], 6)
  ], 64))
}